import i18n from "i18next";

export const endDest = [
    { value: 'AF', label: 'Afghanistan' },
    { value: 'AX', label: 'Aland Islands' },
    { value: 'AL', label: 'Albania' },
    { value: 'DZ', label: 'Algeria' },
    { value: 'AS', label: 'American Samoa' },
    { value: 'AD', label: 'Andorra' },
    { value: 'AO', label: 'Angola' },
    { value: 'AI', label: 'Anguilla' },
    { value: 'AQ', label: 'Antarctica' },
    { value: 'AG', label: 'Antigua and Barbuda' },
    { value: 'AR', label: 'Argentina' },
    { value: 'AM', label: 'Armenia' },
    { value: 'AW', label: 'Aruba' },
    { value: 'AU', label: 'Australia' },
    { value: 'AT', label: 'Austria' },
    { value: 'AZ', label: 'Azerbaijan' },
    { value: 'BS', label: 'Bahamas' },
    { value: 'BH', label: 'Bahrain' },
    { value: 'BD', label: 'Bangladesh' },
    { value: 'BB', label: 'Barbados' },
    { value: 'BY', label: 'Belarus' },
    { value: 'BE', label: 'Belgium' },
    { value: 'BZ', label: 'Belize' },
    { value: 'BJ', label: 'Benin' },
    { value: 'BM', label: 'Bermuda' },
    { value: 'BT', label: 'Bhutan' },
    { value: 'BO', label: 'Bolivia' },
    { value: 'BQ', label: 'Bonaire, Saint Eustatius and Saba' },
    { value: 'BA', label: 'Bosnia and Herzegovina' },
    { value: 'BW', label: 'Botswana' },
    { value: 'BV', label: 'Bouvet Island' },
    { value: 'BR', label: 'Brazil' },
    { value: 'IO', label: 'British Indian Ocean Territory' },
    { value: 'VG', label: 'British Virgin Islands' },
    { value: 'BN', label: 'Brunei' },
    { value: 'BG', label: 'Bulgaria' },
    { value: 'BF', label: 'Burkina Faso' },
    { value: 'BI', label: 'Burundi' },
    { value: 'KH', label: 'Cambodia' },
    { value: 'CM', label: 'Cameroon' },
    { value: 'CA', label: 'Canada' },
    { value: 'CV', label: 'Cape Verde' },
    { value: 'KY', label: 'Cayman Islands' },
    { value: 'CF', label: 'Central African Republic' },
    { value: 'TD', label: 'Chad' },
    { value: 'CL', label: 'Chile' },
    { value: 'CN', label: 'China' },
    { value: 'CX', label: 'Christmas Island' },
    { value: 'CC', label: 'Cocos Islands' },
    { value: 'CO', label: 'Colombia' },
    { value: 'KM', label: 'Comoros' },
    { value: 'CK', label: 'Cook Islands' },
    { value: 'CR', label: 'Costa Rica' },
    { value: 'HR', label: 'Croatia' },
    { value: 'CU', label: 'Cuba' },
    { value: 'CW', label: 'Curacao' },
    { value: 'CY', label: 'Cyprus' },
    { value: 'CZ', label: 'Czech Republic' },
    { value: 'CD', label: 'Democratic Republic of the Congo' },
    { value: 'DK', label: 'Denmark' },
    { value: 'DJ', label: 'Djibouti' },
    { value: 'DM', label: 'Dominica' },
    { value: 'DO', label: 'Dominican Republic' },
    { value: 'TL', label: 'East Timor' },
    { value: 'EC', label: 'Ecuador' },
    { value: 'EG', label: 'Egypt' },
    { value: 'SV', label: 'El Salvador' },
    { value: 'GQ', label: 'Equatorial Guinea' },
    { value: 'ER', label: 'Eritrea' },
    { value: 'EE', label: 'Estonia' },
    { value: 'ET', label: 'Ethiopia' },
    { value: 'FK', label: 'Falkland Islands' },
    { value: 'FO', label: 'Faroe Islands' },
    { value: 'FJ', label: 'Fiji' },
    { value: 'FI', label: 'Finland' },
    { value: 'FR', label: 'France' },
    { value: 'GF', label: 'French Guiana' },
    { value: 'PF', label: 'French Polynesia' },
    { value: 'TF', label: 'French Southern Territories' },
    { value: 'GA', label: 'Gabon' },
    { value: 'GM', label: 'Gambia' },
    { value: 'GE', label: 'Georgia' },
    { value: 'DE', label: 'Germany' },
    { value: 'GH', label: 'Ghana' },
    { value: 'GI', label: 'Gibraltar' },
    { value: 'GR', label: 'Greece' },
    { value: 'GL', label: 'Greenland' },
    { value: 'GD', label: 'Grenada' },
    { value: 'GP', label: 'Guadeloupe' },
    { value: 'GU', label: 'Guam' },
    { value: 'GT', label: 'Guatemala' },
    { value: 'GG', label: 'Guernsey' },
    { value: 'GN', label: 'Guinea' },
    { value: 'GW', label: 'Guinea-Bissau' },
    { value: 'GY', label: 'Guyana' },
    { value: 'HT', label: 'Haiti' },
    { value: 'HM', label: 'Heard Island and McDonald Islands' },
    { value: 'HN', label: 'Honduras' },
    { value: 'HK', label: 'Hong Kong' },
    { value: 'HU', label: 'Hungary' },
    { value: 'IS', label: 'Iceland' },
    { value: 'IN', label: 'India' },
    { value: 'ID', label: 'Indonesia' },
    { value: 'IR', label: 'Iran' },
    { value: 'IQ', label: 'Iraq' },
    { value: 'IE', label: 'Ireland' },
    { value: 'IM', label: 'Isle of Man' },
    { value: 'IL', label: 'Israel' },
    { value: 'IT', label: 'Italy' },
    { value: 'CI', label: 'Ivory Coast' },
    { value: 'JM', label: 'Jamaica' },
    { value: 'JP', label: 'Japan' },
    { value: 'JE', label: 'Jersey' },
    { value: 'JO', label: 'Jordan' },
    { value: 'KZ', label: 'Kazakhstan' },
    { value: 'KE', label: 'Kenya' },
    { value: 'KI', label: 'Kiribati' },
    { value: 'XK', label: 'Kosovo' },
    { value: 'KW', label: 'Kuwait' },
    { value: 'KG', label: 'Kyrgyzstan' },
    { value: 'LA', label: 'Laos' },
    { value: 'LV', label: 'Latvia' },
    { value: 'LB', label: 'Lebanon' },
    { value: 'LS', label: 'Lesotho' },
    { value: 'LR', label: 'Liberia' },
    { value: 'LY', label: 'Libya' },
    { value: 'LI', label: 'Liechtenstein' },
    { value: 'LT', label: 'Lithuania' },
    { value: 'LU', label: 'Luxembourg' },
    { value: 'MO', label: 'Macao' },
    { value: 'MK', label: 'Macedonia' },
    { value: 'MG', label: 'Madagascar' },
    { value: 'MW', label: 'Malawi' },
    { value: 'MY', label: 'Malaysia' },
    { value: 'MV', label: 'Maldives' },
    { value: 'ML', label: 'Mali' },
    { value: 'MT', label: 'Malta' },
    { value: 'MH', label: 'Marshall Islands' },
    { value: 'MQ', label: 'Martinique' },
    { value: 'MR', label: 'Mauritania' },
    { value: 'MU', label: 'Mauritius' },
    { value: 'YT', label: 'Mayotte' },
    { value: 'MX', label: 'Mexico' },
    { value: 'FM', label: 'Micronesia' },
    { value: 'MD', label: 'Moldova' },
    { value: 'MC', label: 'Monaco' },
    { value: 'MN', label: 'Mongolia' },
    { value: 'ME', label: 'Montenegro' },
    { value: 'MS', label: 'Montserrat' },
    { value: 'MA', label: 'Morocco' },
    { value: 'MZ', label: 'Mozambique' },
    { value: 'MM', label: 'Myanmar' },
    { value: 'NA', label: 'Namibia' },
    { value: 'NR', label: 'Nauru' },
    { value: 'NP', label: 'Nepal' },
    { value: 'NL', label: 'Netherlands' },
    { value: 'AN', label: 'Netherlands Antilles' },
    { value: 'NC', label: 'New Caledonia' },
    { value: 'NZ', label: 'New Zealand' },
    { value: 'NI', label: 'Nicaragua' },
    { value: 'NE', label: 'Niger' },
    { value: 'NG', label: 'Nigeria' },
    { value: 'NU', label: 'Niue' },
    { value: 'NF', label: 'Norfolk Island' },
    { value: 'KP', label: 'North Korea' },
    { value: 'MP', label: 'Northern Mariana Islands' },
    { value: 'NO', label: 'Norway' },
    { value: 'OM', label: 'Oman' },
    { value: 'PK', label: 'Pakistan' },
    { value: 'PW', label: 'Palau' },
    { value: 'PS', label: 'Palestinian Territory' },
    { value: 'PA', label: 'Panama' },
    { value: 'PG', label: 'Papua New Guinea' },
    { value: 'PY', label: 'Paraguay' },
    { value: 'PE', label: 'Peru' },
    { value: 'PH', label: 'Philippines' },
    { value: 'PN', label: 'Pitcairn' },
    { value: 'PL', label: 'Poland' },
    { value: 'PT', label: 'Portugal' },
    { value: 'PR', label: 'Puerto Rico' },
    { value: 'QA', label: 'Qatar' },
    { value: 'CG', label: 'Republic of the Congo' },
    { value: 'RE', label: 'Reunion' },
    { value: 'RO', label: 'Romania' },
    { value: 'RU', label: 'Russia' },
    { value: 'RW', label: 'Rwanda' },
    { value: 'BL', label: 'Saint Barthelemy' },
    { value: 'SH', label: 'Saint Helena' },
    { value: 'KN', label: 'Saint Kitts and Nevis' },
    { value: 'LC', label: 'Saint Lucia' },
    { value: 'MF', label: 'Saint Martin' },
    { value: 'PM', label: 'Saint Pierre and Miquelon' },
    { value: 'VC', label: 'Saint Vincent and the Grenadines' },
    { value: 'WS', label: 'Samoa' },
    { value: 'SM', label: 'San Marino' },
    { value: 'ST', label: 'Sao Tome and Principe' },
    { value: 'SA', label: 'Saudi Arabia' },
    { value: 'SN', label: 'Senegal' },
    { value: 'RS', label: 'Serbia' },
    { value: 'CS', label: 'Serbia and Montenegro' },
    { value: 'SC', label: 'Seychelles' },
    { value: 'SL', label: 'Sierra Leone' },
    { value: 'SG', label: 'Singapore' },
    { value: 'SX', label: 'Sint Maarten' },
    { value: 'SK', label: 'Slovakia' },
    { value: 'SI', label: 'Slovenia' },
    { value: 'SB', label: 'Solomon Islands' },
    { value: 'SO', label: 'Somalia' },
    { value: 'ZA', label: 'South Africa' },
    { value: 'GS', label: 'South Georgia and the South Sandwich Island' },
    { value: 'KR', label: 'South Korea' },
    { value: 'SS', label: 'South Sudan' },
    { value: 'ES', label: 'Spain' },
    { value: 'LK', label: 'Sri Lanka' },
    { value: 'SD', label: 'Sudan' },
    { value: 'SR', label: 'Suriname' },
    { value: 'SJ', label: 'Svalbard and Jan Mayen' },
    { value: 'SZ', label: 'Swaziland' },
    { value: 'SE', label: 'Sweden' },
    { value: 'CH', label: 'Switzerland' },
    { value: 'SY', label: 'Syria' },
    { value: 'TW', label: 'Taiwan' },
    { value: 'TJ', label: 'Tajikistan' },
    { value: 'TZ', label: 'Tanzania' },
    { value: 'TH', label: 'Thailand' },
    { value: 'TG', label: 'Togo' },
    { value: 'TK', label: 'Tokelau' },
    { value: 'TO', label: 'Tonga' },
    { value: 'TT', label: 'Trinidad and Tobago' },
    { value: 'TN', label: 'Tunisia' },
    { value: 'TR', label: 'Turkey' },
    { value: 'TM', label: 'Turkmenistan' },
    { value: 'TC', label: 'Turks and Caicos Islands' },
    { value: 'TV', label: 'Tuvalu' },
    { value: 'VI', label: 'U.S. Virgin Islands' },
    { value: 'UG', label: 'Uganda' },
    { value: 'UA', label: 'Ukraine' },
    { value: 'AE', label: 'United Arab Emirates' },
    { value: 'GB', label: 'United Kingdom' },
    { value: 'US', label: 'United States' },
    { value: 'UM', label: 'United States Minor Outlying Islands' },
    { value: 'UY', label: 'Uruguay' },
    { value: 'UZ', label: 'Uzbekistan' },
    { value: 'VU', label: 'Vanuatu' },
    { value: 'VA', label: 'Vatican' },
    { value: 'VE', label: 'Venezuela' },
    { value: 'VN', label: 'Vietnam' },
    { value: 'WF', label: 'Wallis and Futuna' },
    { value: 'EH', label: 'Western Sahara' },
    { value: 'YE', label: 'Yemen' },
    { value: 'ZM', label: 'Zambia' },
    { value: 'ZW', label: 'Zimbabwe' }
];

export const projectStatus = [
    //{value: 'NOTSTARTED', label: 'Not Started'},
    { value: 'OPEN', label: 'Open' },
    //{value: 'STARTED',label: 'Started'},
    { value: 'ONHOLD', label: 'On Hold' },
    //{value: 'SUBMITTOCUST',label: 'Submitted to Customer'},
    //{value: 'WON',label: 'Won'},
    //{value: 'LOST',label: 'Lost'},
    { value: 'CLOSED', label: 'Closed' },
    { value: 'CANCELLED', label: 'Cancelled' },
]

export const pkgStatus = [
    { value: 'NOTSTARTED', label: 'Not Started' },
    //{value: 'OPEN', label: 'Open'},
    { value: 'IN PROGRESS', label: 'In Progress' }, //TASK- 23768896 = Change the status Started to In Progress in the Package Status Field
    { value: 'ONHOLD', label: 'On Hold' },
    { value: 'QUOTE SENT', label: 'Quote Sent' },//TASK- 23768897 = Change the selection "Submitted to Customer"  to "Quote Sent"
    { value: 'WON', label: 'Won' },
    { value: 'LOST', label: 'Lost' },
    { value: 'CLOSED', label: 'Closed' },
    { value: 'CANCELLED', label: 'Cancelled' },
]

export const quotePriorityStatus = [
    { value: 'VERY HIGH', label: 'Very High' },
    { value: 'HIGH', label: 'High' },
    { value: 'MEDIUM', label: 'Medium' },
    { value: 'LOW', label: 'Low' },
]

export const pricingTypeStatus = [
    { value: 'NO CHANGE', label: 'No Change' },
    { value: 'FIRM', label: 'Firm' },
    { value: 'BUDGETARY', label: 'Budgetary' },
]

export const lateReasonCodes = [
    { value: 'AWAITING_CUSTOMER_RESPONSE', label: 'Awaiting Customer Response' },
    { value: 'AWAITING_CUSTOMER_CLARIFICATION', label: 'Awaiting Customer Clarification' },
    { value: 'CUSTOMER_SHORT_LEAD_TIME_REQUEST', label: 'Customer Short Lead Time Request' },
    { value: 'SALES_DELAYS', label: 'Sales Delays' },
    { value: 'LEGAL_TRADE_COMPLIANCE_DELAYS', label: 'Legal & Trade Compliance Delays' },
    { value: 'SPECIALIST_DELAYS', label: 'Specialist Delays' },
    { value: 'SPECIALS_ETO_DELAYS', label: 'Specials & ETO Delays' },
    { value: 'OTHER_SUPPORT_GROUP_DELAYS', label: 'Other Support Group Delays' },
    { value: 'PMO_CAPACITY', label: 'PMO Capacity' },
    { value: 'SYSTEM_OR_APPLICATION', label: 'System or Application' },
    { value: 'AVAILABILITY', label: 'Availability' },
    { value: 'BUYOUTS', label: 'Buyouts' },
    { value: 'LATE_DUE_TO_PMO_ERRORS', label: 'Late Due to PMO Errors' },
    { value: 'OTHER', label: 'Other' },
]

export const currencies =
    [
        { "label": "Afghani", "value": "AFN", 'symb': '؋' },
        { "label": "Algerian Dinar", "value": "DZD", 'symb': 'دج' },
        { "label": "Argentine Peso", "value": "ARS", 'symb': '$' },
        { "label": "Australia Dollar", "value": "AUD", 'symb': 'A$' },
        { "label": "Bahraini Dinar", "value": "BHD", 'symb': '.د.ب' },
        { "label": "Baht", "value": "THB", 'symb': '฿' },
        { "label": "Belarussian Ruble", "value": "BYR", 'symb': 'Rbl' },
        { "label": "Belarussian Ruble (new)", "value": "BYN", 'symb': 'Rbl' },
        { "label": "Bolivar", "value": "VEB", 'symb': 'Bs' },
        { "label": "Boliviano", "value": "BOB", 'symb': '$b' },
        { "label": "Brazilian Real", "value": "BRL", 'symb': 'R$' },
        { "label": "Brunei Dollar", "value": "BND", 'symb': 'B$' },
        { "label": "Bulgarian Lev", "value": "BGN", 'symb': 'Лв.' },
        { "label": "CFA Franc BEAC", "value": "XAF", 'symb': 'FCFA' },
        { "label": "Canadian Dollar", "value": "CAD", 'symb': 'C$' },
        { "label": "Chilean Peso", "value": "CLP", 'symb': 'CLP$' },
        { "label": "Colombian Peso", "value": "COP", 'symb': 'Col$' },
        { "label": "Convertible Marks", "value": "BAM", 'symb': 'KM' },
        { "label": "Costa Rican Colon", "value": "CRC", 'symb': '₡' },
        { "label": "Croatian kuna", "value": "HRK", 'symb': 'kn' },
        { "label": "Czech Koruna", "value": "CZK", 'symb': 'Kč' },
        { "label": "Danish Krone", "value": "DKK", 'symb': 'Kr.' },
        { "label": "Deutsche Mark", "value": "DEM", 'symb': 'DM' },
        { "label": "Dominican Peso", "value": "DOP", 'symb': 'RD$' },
        { "label": "Dong", "value": "VND", 'symb': '₫' },
        { "label": "EURO", "value": "EUR", 'symb': '€' },
        { "label": "Egyptian Pound", "value": "EGP", 'symb': 'E£' },
        { "label": "Forint", "value": "HUF", 'symb': 'Ft' },
        { "label": "Hong Kong Dollar", "value": "HKD", 'symb': 'HK$' },
        { "label": "Hryvnia", "value": "UAH", 'symb': '₴' },
        { "label": "Iraqi Dinar", "value": "IQD", 'symb': 'ع.د' },
        { "label": "Jordanian Dinar", "value": "JOD", 'symb': 'د.ا' },
        { "label": "Kenyan Shilling", "value": "KES", 'symb': '' },
        { "label": "Kina", "value": "PGK", 'symb': 'K' },
        { "label": "Kuwaiti Dinar", "value": "KWD", 'symb': 'د.ك' },
        { "label": "Kwacha", "value": "ZMK", 'symb': 'ZK' },
        { "label": "Kwanza", "value": "AOA", 'symb': 'Kz' },
        { "label": "Kyat", "value": "MMK", 'symb': 'K' },
        { "label": "Latvian Lats", "value": "LVL", 'symb': 'ℒ𝓈' },
        { "label": "Lebanese Pound", "value": "LBP", 'symb': 'ل.ل.' },
        { "label": "Libyan Dinar", "value": "LYD", 'symb': 'ل.د' },
        { "label": "Lithuanian Litas", "value": "LTL", 'symb': 'Lt' },
        { "label": "MALAYSIAN RINGGIT", "value": "MYR", 'symb': 'RM' },
        { "label": "Mexican Peso", "value": "MXN", 'symb': 'Mex$' },
        { "label": "Moroccan Dirham", "value": "MAD", 'symb': 'DH' },
        { "label": "NEW AZERBAIJANIAN MANAT", "value": "AZN", 'symb': '₼' },
        { "label": "Naira", "value": "NGN", 'symb': '₦' },
        { "label": "Netherlands Guilder", "value": "NLG", 'symb': 'ƒ' },
        { "label": "New Romanian Leu", "value": "RON", 'symb': 'lei' },
        { "label": "New Taiwan Dollar", "value": "TWD", 'symb': 'NT$' },
        { "label": "New Turkish Lira", "value": "TRY", 'symb': 'YTL' },
        { "label": "Newzealand Dollar", "value": "NZD", 'symb': 'NZ$' },
        { "label": "Norwegian Krone", "value": "NOK", 'symb': 'kr' },
        { "label": "Nuevo Sol", "value": "PEN", 'symb': 'S/' },
        { "label": "Pakistan Rupee", "value": "PKR", 'symb': 'Rs' },
        { "label": "Peso Uruguayo", "value": "UYU", 'symb': '$U' },
        { "label": "Philippine Peso", "value": "PHP", 'symb': '₱' },
        { "label": "Polish Zloty", "value": "PLN", 'symb': 'zł' },
        { "label": "Pound Sterling", "value": "GBP", 'symb': '£' },
        { "label": "Qatari Rial", "value": "QAR", 'symb': 'ر.ق' },
        { "label": "Rand", "value": "ZAR", 'symb': 'R' },
        { "label": "Rial Omani", "value": "OMR", 'symb': 'ر.ع.' },
        { "label": "Rupee", "value": "INR", 'symb': '₹' },
        { "label": "Rupiah", "value": "IDR", 'symb': 'Rp' },
        { "label": "Russian Ruble", "value": "RUB", 'symb': '₽' },
        { "label": "SINGAPORE DOLLAR", "value": "SGD", 'symb': 'S$' },
        { "label": "SOUTH KOREAN WON", "value": "KRW", 'symb': '₩' },
        { "label": "Saudi Riyal", "value": "SAR", 'symb': '﷼' },
        { "label": "Shekel", "value": "ILS", 'symb': '₪' },
        { "label": "Slovak Koruna", "value": "SKK", 'symb': 'Sk' },
        { "label": "Sri Lanka Rupee", "value": "LKR", 'symb': 'Rs' },
        { "label": "Swedish Krona", "value": "SEK", 'symb': 'kr' },
        { "label": "Swiss Franc", "value": "CHF", 'symb': 'CHf' },
        { "label": "Taka", "value": "BDT", 'symb': '৳' },
        { "label": "Tenge", "value": "KZT", 'symb': '₸' },
        { "label": "Trinidad and Tobago Dollar", "value": "TTD", 'symb': 'TT$' },
        { "label": "Tunisian Dinar", "value": "TND", 'symb': 'د.ت' },
        { "label": "UAE Dirham", "value": "AED", 'symb': 'DH' },
        { "label": "US dollar", "value": "USD", 'symb': '$' },
        { "label": "VEN", "value": "VEN", 'symb': 'VEN' },
        { "label": "Venezuelan Bolivar Fuerte", "value": "VEF", 'symb': 'Bs' },
        { "label": "Yen", "value": "JPY", 'symb': 'JP¥' },
        { "label": "Yuan", "value": "CNY", 'symb': 'CN¥' },
        { "label": "Zambian Kwacha", "value": "ZMW", 'symb': 'ZK' }
    ]


export const priceList = [
    { 'value': 'PSS Mid-tier CE Parts Price List' },
    { 'value': 'APL Global Price List' },
    { 'value': 'PWS Price List' },
    { 'value': 'MMI CORPORATE PRICE LIST' },
    { 'value': 'DMC Global Price List 10.2020' },
    { 'value': 'EPM MS Billing Items Price List' },
    { 'value': 'EMR UOM All Items Price List' },
    { 'value': 'FMC Global Price List 2022' },
    { 'value': 'TAT Global Price List' },
    { 'value': 'RAI Pricelist Master' },
    { 'value': 'LQD MSRP Primary Price List USD' },
    { 'value': 'ROX Global Price List' },
    { 'value': 'PE Price List Migration' },
    { 'value': 'VLVS Parts List Price USD' },
    { 'value': 'ISV CORPORATE PRICE LIST' },
    { 'value': 'RMT RNI CORPORATE OCT 2021' },
    { 'value': 'GC Global Price List' },
    { 'value': 'TDS 2020 Global Price List' },
    { 'value': 'NSD Global Price List' },
    { 'value': 'REG Global Price List 2016' },
    { 'value': 'PAD Price List USD' },
    { 'value': 'RMT CORPORATE OCT 2021' },
    { 'value': 'VC Global Price List' },
    { 'value': 'EMR UOM Price List' },
    { 'value': 'BR Price List COMPERJ' },
    { 'value': 'MSS Global Price List' },
    { 'value': 'VA Pricelist Master' },
    { 'value': 'RAS Global Price List 2022' }
]



export const configJSON = {
    "display_div": "configDiv",
    "activeOrgId": "",
    "obo": "",
    "model_name": "",
    "child_name1": "",
    "child_name2": "",
    "quantity": "",
    "config_header_id": "",
    "config_rev_nbr": "",
    "source": "WSC",
    "division_code": "",
    "language": "US",
    "pre_config_base_model_String": "",
    "pre_config_sub_model1_string": "",
    "pre_config_sub_model2_string": "",
    "pre_config_sub_model3_string": "",
    "domain": "",
    "org_id": "",
    "pricing_region": "US",
    "currency_code": "USD",
    "contact_party_id": "",
    "customer_account_id": "",
    "invoice_to_party_id": "",
    "sold_to_paty_id": "",
    "ship_to_paty_id": "",
    "end_to_party_site_id": "",
    "view_price": "true",
    "is_sales_rep": "FALSE",
    "isPunchOut": "YES",
    "adminUser": "true",
    "sizing_refrence_id": ""
}

export const division_code = [
    { value: 'RMT', label: 'RMT Flow Advisor' },
    { value: 'MMI', label: 'Flow Advisor' }]

export const tagStatus = [
    { value: 'ACTIVE', label: 'ACTIVE' },
    // { value: 'INACTIVE', label: 'INACTIVE' },
    { value: 'VALIDATE', label: 'VALIDATE' },
    { value: 'COMPLETE', label: 'COMPLETE' },
    { value: 'EDITING', label: 'EDITING' },
    { value: 'ON_HOLD', label: 'ON_HOLD' },
    { value: 'NEW_TAG', label: 'NEW_TAG' },
    { value: 'UPDATED_FIELD', label: 'UPDATED_FIELD' },
    { value: 'DELETE', label: 'DELETE' }
]

export const tagStatusNew = [
    {
        value: 'tag_line_status', label: 'Tag Line Status', actions: [
            { value: 'ACTIVE', label: 'ACTIVE' },
            // { value: 'INACTIVE', label: 'INACTIVE' },
            { value: 'VALIDATE', label: 'VALIDATE' },
            { value: 'COMPLETE', label: 'COMPLETE' },
            { value: 'EDITING', label: 'EDITING' },
            { value: 'ON_HOLD', label: 'ON_HOLD' },
            { value: 'NEW_TAG', label: 'NEW_TAG' },
            { value: 'UPDATED_FIELD', label: 'UPDATED_FIELD' },
            { value: 'DELETE', label: 'DELETE' }
        ]
    },
    // { value: 'BATCHCONFIGURE', label: 'Batch Configure'}
]


export const tagStatusActions = [
    { value: 'ACTIVE', label: 'ACTIVE' },
    // { value: 'INACTIVE', label: 'INACTIVE' },
    { value: 'VALIDATE', label: 'VALIDATE' },
    { value: 'COMPLETE', label: 'COMPLETE' },
    { value: 'EDITING', label: 'EDITING' },
    { value: 'ON_HOLD', label: 'ON_HOLD' },
    { value: 'NEW_TAG', label: 'NEW_TAG' },
    { value: 'UPDATED_FIELD', label: 'UPDATED_FIELD' },
    { value: 'DELETE', label: 'DELETE' }
]



export const tagStatusNew2 = ['ACTIVE', /*'INACTIVE',*/ 'VALIDATE', 'COMPLETE', 'EDITING', 'ON_HOLD', 'NEW_TAG', 'UPDATED_FIELD', 'DELETE']




export const fiscalYear = [
    { value: '2016', label: '2016' },
    { value: '2017', label: '2017' },
    { value: '2018', label: '2018' },
    { value: '2019', label: '2019' },
    { value: '2020', label: '2020' },
    { value: '2021', label: '2021' },
    { value: '2022', label: '2022' }

]